export default {
  sourceGeo: [],
  isLoading: false,
  error: null,
};
